<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="exam_analysis flex flexcolumn Flexalign">
      <div class="exma_title flex Flexalign pt-30">
        <div class="flex Flexalign cursor_pointer" @click="backExamFinish">
          <el-icon>
            <ArrowLeft />
          </el-icon>
          <div class="ml-5">返回</div>
        </div>
        <div class="exam_result ml-10 flex Flexalign">
          |
          <div class="ml-10">测评报告</div>
        </div>
      </div>
      <div class="analysis_content mt-30 flex flexcolumn Flexalign">
        <el-image class="exam_analysis_title mt-30" :src="iconPath('exam_analysis_title.png')"></el-image>
        <div class="exam_analysis_title_text">Ability Assessment Report</div>
        <div class="test_info_content">
          <div class="homework_difficult flex Flexalign mt-40">
            <div class="line_green"></div>
            <div class="difficult_text ml-20">作业描述</div>
          </div>
          <div class="user_info flex Flexalign FlexBetween mt-30">
            <div class="flex">
              <div>姓名</div>
              <div class="user_value ml-50">{{ reportInfo?.reportStatistics?.name }}</div>
            </div>
            <div class="flex">
              <div>性别</div>
              <div class="user_value ml-50">{{ reportInfo?.reportStatistics?.sex }}</div>
            </div>
            <div class="flex">
              <div>手机号</div>
              <div class="user_value ml-50">
                {{ reportInfo?.reportStatistics?.phone }}
              </div>
            </div>
            <div class="flex">
              <div>报告日期</div>
              <div class="user_value ml-50">
                {{ reportInfo?.reportStatistics?.reportTime }}
              </div>
            </div>
          </div>
          <el-table :data="reportInfo.examTabel" border style="width: 100%" class="mt-40">
            <el-table-column prop="score" label="得分" />
            <el-table-column prop="questionCount" label="试题数" />
            <el-table-column prop="answerSituation" label="答对/答错/部分正确" />
            <el-table-column prop="scoreRate" label="得分率" />
            <el-table-column prop="timeTaken" label="总用时" />
          </el-table>
          <div class="homework_difficult flex Flexalign mt-50">
            <div class="line_green"></div>
            <div class="difficult_text ml-20">测评结果</div>
          </div>
          <div class="test_result flex Flexalign">
            <div class="test_result_left mt-30 pr-30 pb-20">
              <div class="test_result_top flex Flexalign">
                <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon1.png')"></el-image>
                <div class="ml-10">综合评定</div>
              </div>
              <div class="mt-20 test_result_evaluation">
                {{ reportInfo.reportComment }}
              </div>
            </div>
            <div class="test_result_left test_result_right mt-30 pr-30 pb-20 pl-20">
              <div class="test_result_top flex Flexalign">
                <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon2.png')"></el-image>
                <div class="ml-10">提升建议</div>
              </div>
              <div class="mt-20 test_result_evaluation">
                {{ reportInfo.reportSuggest }}
              </div>
            </div>
          </div>
          <div class="homework_difficult flex Flexalign mt-50">
            <div class="line_green"></div>
            <div class="difficult_text ml-20">试卷分析</div>
          </div>
          <div class="paper_analysis mt-20">
            {{ reportInfo.reportPaperAnalyse }}
          </div>
          <div class="flex Flexalign question_analysis mt-30">
            <div class="question_analysis_one">
              <div class="flex Flexalign FlexBetween pr-20">
                <div class="test_result_top flex Flexalign">
                  <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon3.png')"></el-image>
                  <div class="ml-10">试题分析</div>
                </div>
                <div class="question_analysis_one_text">
                  共
                  <span class="text_active">{{
                    reportInfo?.reportStatistics?.questionCount
                  }}</span>
                  题
                </div>
              </div>
              <div class="echarts_box">
                <questionAnalysisBar ref="questionAnalysisBar"></questionAnalysisBar>
              </div>
            </div>
            <div class="question_analysis_one">
              <div class="flex Flexalign FlexBetween pr-20 pl-10">
                <div class="test_result_top flex Flexalign">
                  <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon4.png')"></el-image>
                  <div class="ml-10">难度分析</div>
                </div>
              </div>
              <div class="echarts_box">
                <difficultAnalysisPie ref="difficultAnalysisPie"></difficultAnalysisPie>
              </div>
            </div>
            <div class="question_analysis_one question_analysis_one_border">
              <div class="flex Flexalign FlexBetween pr-20 pl-10">
                <div class="test_result_top flex Flexalign">
                  <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon5.png')"></el-image>
                  <div class="ml-10">答题情况</div>
                </div>
                <div class="question_analysis_one_text flex Flexalign">
                  <div class="do_status"></div>
                  <div class="ml-15">正确</div>
                  <div class="do_status do_status_1 ml-15"></div>
                  <div class="ml-15">错误</div>
                  <div class="do_status do_status_2 ml-15"></div>
                  <div class="ml-15">部分正确</div>
                </div>
              </div>
              <div class="echarts_box scroll_y hidden_scroll pl-10">
                <answerSheetAnalysis ref="answerSheetAnalysis"></answerSheetAnalysis>
              </div>
            </div>
          </div>
          <div class="homework_difficult flex Flexalign mt-50">
            <div class="line_green"></div>
            <div class="difficult_text ml-20">答题分析</div>
          </div>
          <div class="paper_analysis mt-20">
            {{ reportInfo.reportAnswerAnalyse }}
          </div>
          <div class="test_result flex Flexalign">
            <div class="test_result_left mt-30 pr-30 pb-20">
              <div class="test_result_top flex Flexalign">
                <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon6.png')"></el-image>
                <div class="ml-10">稳定性分析</div>
              </div>
              <div class="test_result_evaluation_echarts scroll_y hidden_scroll">
                <stabilityAnalysisRadar ref="stabilityAnalysisRadar"></stabilityAnalysisRadar>
              </div>
            </div>
            <div class="test_result_left test_result_right mt-30 pr-30 pb-20 pl-20">
              <div class="test_result_top flex Flexalign">
                <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon7.png')"></el-image>
                <div class="ml-10">稳定率分析</div>
              </div>
              <div class="test_result_evaluation_echarts scroll_y hidden_scroll">
                <!-- <stabilityAnalysisLineArea ref="stabilityAnalysisLineArea"></stabilityAnalysisLineArea> -->
                <stabilityAnalysisLine ref="stabilityAnalysisLine"></stabilityAnalysisLine>
              </div>
            </div>
          </div>
          <div class="homework_difficult flex Flexalign mt-50">
            <div class="line_green"></div>
            <div class="difficult_text ml-20">能力图谱分析</div>
          </div>
          <div class="paper_analysis mt-20">
            {{ reportInfo.reportAbilityAnalyse }}
          </div>
          <div class="test_result flex Flexalign">
            <div class="test_result_left mt-30 pr-30 pb-20">
              <div class="test_result_top flex Flexalign">
                <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon8.png')"></el-image>
                <div class="ml-10">平均率掌握</div>
              </div>
              <div class="test_result_evaluation_echarts scroll_y hidden_scroll">
                <equalAnalysisGauge ref="equalAnalysisGauge"></equalAnalysisGauge>
              </div>
            </div>
            <div class="test_result_left test_result_right mt-30 pr-30 pb-20 pl-20">
              <div class="test_result_top flex Flexalign">
                <el-image class="exam_analysis_menu_icon1" :src="iconPath('exam_analysis_menu_icon9.png')"></el-image>
                <div class="ml-10">概览</div>
              </div>
              <div class="test_result_evaluation_echarts scroll_y hidden_scroll flex flexcolumn">
                <div class="total_view_top flex Flexalign mt-20">
                  <div class="total_view_one flex flexcolumn Flexalign">
                    <div>知识点数</div>
                    <div class="mt-10 total_view_one_value">
                      {{ reportInfo?.reportStatistics?.knowledge?.KnowledgeTotal || 0 }}
                    </div>
                  </div>
                  <div class="total_view_one flex flexcolumn Flexalign">
                    <div>掌握情况</div>
                    <div class="mt-10 total_view_one_value total_view_one_value_blue">
                      {{
                        getKnowledgeDivideLabel(
                          reportInfo?.reportStatistics?.knowledge.knowledgeDivide
                        )
                      }}
                    </div>
                  </div>
                  <div class="total_view_one flex flexcolumn Flexalign">
                    <div>掌握率</div>
                    <div class="mt-10 total_view_one_value">
                      {{ reportInfo?.reportStatistics?.knowledge.knowledgeDivide }}
                      <span class="total_view_one_value_unit">%</span>
                    </div>
                  </div>
                  <div class="total_view_one flex flexcolumn Flexalign">
                    <div>薄弱项</div>
                    <div class="mt-10 total_view_one_value">
                      {{ reportInfo?.reportStatistics?.knowledge?.notGraspCount }}
                    </div>
                  </div>
                </div>
                <div class="distribution_map mt-20">掌握度分布图</div>
                <div class="flex-1 mt-10">
                  <totalAnalysis3DPie ref="totalAnalysis3DPie"></totalAnalysis3DPie>
                </div>
              </div>
            </div>
          </div>

          <div class="homework_difficult flex Flexalign mt-50">
            <div class="line_green"></div>
            <div class="difficult_text ml-20">解题分析</div>
          </div>
          <div class="paper_analysis mt-20">
            {{ reportInfo.reportRespondenceAnalyse }}
          </div>
          <div class="test_result flex Flexalign mt-30 mb-30">
            <statisticalAnalysisTable ref="statisticalAnalysisTable"></statisticalAnalysisTable>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 30px"></div>
    </div>
  </moe-page>
</template>

<script>
import questionAnalysisBar from "@/components/echarts/questionAnalysisBar.vue";
import difficultAnalysisPie from "@/components/echarts/difficultAnalysisPie.vue";
import answerSheetAnalysis from "@/components/echarts/answerSheetAnalysis.vue";
import stabilityAnalysisRadar from "@/components/echarts/stabilityAnalysisRadar.vue";
// import stabilityAnalysisLineArea from "@/components/echarts/stabilityAnalysisLineArea.vue";
import equalAnalysisGauge from "@/components/echarts/equalAnalysisGauge.vue";
import totalAnalysis3DPie from "@/components/echarts/totalAnalysis3DPie.vue";
import statisticalAnalysisTable from "@/components/echarts/statisticalAnalysisTable.vue";
import stabilityAnalysisLine from "@/components/echarts/stabilityAnalysisLine.vue";
export default {
  name: "GjkcH5ExamAnalysis",
  components: {
    questionAnalysisBar,
    difficultAnalysisPie,
    answerSheetAnalysis,
    stabilityAnalysisRadar,
    // stabilityAnalysisLineArea,
    equalAnalysisGauge,
    totalAnalysis3DPie,
    statisticalAnalysisTable,
    stabilityAnalysisLine,
  },

  data() {
    return {
      recordId: "",
      testPaperType: "",
      testInfo: {
        userName: "张三",
        sex: "男",
        age: "14",
        reportDate: "2023-10-19",
        examTabel: [
          {
            score: "85.5分/100分",
            questionCount: "20题",
            answerSituation: "14/2/4",
            scoreRate: "42.5%",
            timeTaken: "45分23秒",
          },
        ],
        comprehensiveEvaluation:
          "· 用时23分钟，能力突出，正确率达85%，整体表现亮眼· 够充分展开，结构清晰，适当的解释、例证和/或细节· 语言熟练，能使用出不同的句法和词汇。但是在结构、词汇、或是习惯用法上存在明显的次要错误。· 保持进取心态，针对薄弱环节制定专项提升计划，结合错题复盘深化理解",
      },
      reportInfo: {},
      loading: {},
    };
  },

  mounted() {
    this.recordId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).recordId;
    this.testPaperType = this.$Jump.getUrlParams(
      window.location.hash.split("?")[1]
    ).testPaperType;
    if (this.testPaperType == "testPaper") {
      this.getTestPaperReport();
    } else {
      // this.getNewExamRecordInfo();
    }
  },

  methods: {
    backExamFinish() {
      this.$Jump.go(-1);
    },
    getNewExamRecordInfo() {
      this.$Api.exam
        .getNewExamRecordInfo(this.recordId)
        .then((res) => {
          this.reportInfo = res.data.data;
          this.handlerReportInfo();
        })
        .catch(() => { });
    },
    // 测评作答记录
    getTestPaperReport() {
      this.loading = this.$Dialog.loading("报告分析加载中，请耐心等待...");
      this.$Api.testPaper
        .getTestPaperReport(this.recordId)
        .then((res) => {
          this.reportInfo = res.data.data;
          this.handlerReportInfo();
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 掌握率计算
    getKnowledgeRate(knowledgeInfo) {
      if (this.$Tools.empty(knowledgeInfo)) return;
      let notGraspCount = knowledgeInfo.knowledgeInfo;
      let graspCount = knowledgeInfo.graspCount;
      return (graspCount / (notGraspCount + graspCount)).toFixed(2) || 0;
    },

    // 处理报告信息
    handlerReportInfo() {
      this.reportInfo.reportStatistics.questionCount =
        this.reportInfo?.reportStatistics?.correctCount +
        this.reportInfo?.reportStatistics?.errorCount +
        this.reportInfo?.reportStatistics?.partialCorrectCount;
      this.reportInfo.examTabel = [
        {
          score: `${this.reportInfo?.reportStatistics?.score}分/${this.reportInfo?.reportStatistics?.fullScore}分`,
          questionCount: `${this.reportInfo?.reportStatistics?.questionCount}题`,
          answerSituation: `${this.reportInfo?.reportStatistics?.correctCount}/${this.reportInfo?.reportStatistics?.errorCount}/${this.reportInfo?.reportStatistics?.partialCorrectCount}`,
          scoreRate: `${this.reportInfo?.reportStatistics?.scoreRate}%`,
          timeTaken: this.$Tools.secondToHour(
            this.reportInfo?.reportStatistics?.answerSection
          ),
        },
      ];
      // 试题分析
      let salvProName = [];
      let salvProValue = [];
      if (!this.$Tools.empty(this.reportInfo?.reportStatistics?.paperContext)) {
        this.reportInfo?.reportStatistics?.paperContext.forEach((item) => {
          salvProName.push(item.questionTypeName);
          salvProValue.push(item.count);
        });
      }
      this.$refs.questionAnalysisBar.initCharts(salvProName, salvProValue);

      // 难度分析
      let chartDom = [];
      if (!this.$Tools.empty(this.reportInfo?.reportStatistics?.difficultyMap)) {
        for (let key in this.reportInfo?.reportStatistics?.difficultyMap) {
          chartDom.push({
            name: key,
            value: this.reportInfo?.reportStatistics?.difficultyMap[key],
          });
        }
      }
      this.$refs.difficultAnalysisPie.chartData = chartDom;
      this.$refs.difficultAnalysisPie.initCharts();

      // 答题分析 answerSheetAnalysis
      // let topicList = [];
      this.$refs.answerSheetAnalysis.topicList = this.reportInfo?.reportStatistics?.paperContext;

      // 稳定性分析
      let stabilityAnalysisData = [];
      let indicator = [];
      let difficultList = [
        {
          name: "超易",
          field: "veryEasyCorrectRate",
        },
        {
          name: "特难",
          field: "veryHardCorrectRate",
        },
        {
          name: "困难",
          field: "hardCorrectRate",
        },
        {
          name: "中档",
          field: "mediumCorrectRate",
        },
        {
          name: "容易",
          field: "easyCorrectRate",
        },
      ];
      if (!this.$Tools.empty(this.reportInfo?.reportStatistics?.difficultyScoreRule)) {
        for (let key in this.reportInfo?.reportStatistics?.difficultyScoreRule) {
          stabilityAnalysisData.push(
            this.reportInfo?.reportStatistics?.difficultyScoreRule[key]
          );
          let nameInfo = difficultList.filter((item) => item.field == key)[0];
          indicator.push({ name: nameInfo.name, max: 100 });
        }
      }
      this.$refs.stabilityAnalysisRadar.initCharts(stabilityAnalysisData, indicator);

      // 稳定率分析
      let correctData = [];
      if (!this.$Tools.empty(this.reportInfo?.reportStatistics?.difficultyCorrectRule)) {
        for (let key in this.reportInfo?.reportStatistics?.difficultyCorrectRule) {
          let nameInfo = difficultList.filter((item) => item.field == key)[0];
          // 判断当前难度是否有题（数量是否为0），没有题目则没数据而不是0
          if (this.reportInfo?.reportStatistics?.difficultyMap[nameInfo.name]) {
            correctData.push(
              this.reportInfo?.reportStatistics?.difficultyCorrectRule[key]
            );
          } else {
            correctData.push(null);
          }
        }
      }
      this.$refs.stabilityAnalysisLine.initCharts(correctData);

      // 平均率掌握
      if (!this.$Tools.empty(this.reportInfo?.reportStatistics?.knowledge)) {
        this.$refs.equalAnalysisGauge.initCharts(
          this.reportInfo?.reportStatistics?.knowledge.knowledgeDivide
        );
      }

      // 概览
      let optionData = [
        { id: 0, name: "未掌握", num: 50, itemStyle: { color: "#FE904B" } },
        { id: 1, name: "已掌握", num: 10, itemStyle: { color: "#30BEFD" } },
        { id: 2, name: "熟练掌握", num: 20, itemStyle: { color: "#41C38F" } },
      ];
      if (!this.$Tools.empty(this.reportInfo?.reportStatistics?.knowledge)) {
        optionData[0].num = this.reportInfo?.reportStatistics?.knowledge.notGraspCount;
        optionData[1].num = this.reportInfo?.reportStatistics?.knowledge.graspCount;
        optionData[2].num = this.reportInfo?.reportStatistics?.knowledge.practisedGraspCount;
      }
      this.$refs.totalAnalysis3DPie.init(optionData);

      //  解题分析
      this.$refs.statisticalAnalysisTable.statisticalAnalysisData = this.reportInfo?.reportStatistics?.analysis;
    },
    getKnowledgeDivideLabel(percentage) {
      let imageName = '';
      if (percentage > 90) {
        // imageName = 'judge5.png';
        imageName = "知识掌控者";
      } else if (percentage > 80) {
        // imageName = 'judge3.png';
        imageName = "学霸附体";
      } else if (percentage > 70) {
        // imageName = 'judge4.png';
        imageName = "学有所成";
      } else if (percentage > 60) {
        // imageName = 'judge2.png';
        imageName = "锦鲤护体";
      } else {
        // imageName = 'judge1.png';
        imageName = "基础构建中";
      }
      return imageName
    },
  },
};
</script>

<style lang="scss" scoped>
.exam_analysis {
  width: 100%;
  // min-height: 100vh;
  background: url("/public/static/icon/exam_analysis_bg.png") no-repeat;
  background-size: 100% 100%;

  .exma_title {
    width: $pageMainWidth;
    color: rgb(36, 24, 24);

    .exam_result {
      color: rgba(48, 48, 48, 1);
    }
  }

  .analysis_content {
    width: $pageMainWidth;
    min-height: 3000px;
    background: #ffffff;
    border-radius: 16px;

    .exam_analysis_title {
      width: 384px;
      height: 70px;
    }

    .exam_analysis_title_text {
      font-size: 18px;
      color: #c9c9c9;
    }

    .test_info_content {
      width: 1100px;

      .homework_difficult {
        .line_green {
          width: 3px;
          height: 16px;
          background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
          border-radius: 4px;
        }

        .difficult_text {
          font-size: 18px;
          font-weight: 500;
          color: #111111;
        }
      }

      .user_info {
        color: #909090;

        .user_value {
          color: #303030;
        }
      }

      :deep(.el-table th.el-table__cell) {
        background-color: #effff9;
        height: 63px;
      }

      :deep(.el-table td.el-table__cell),
      .el-table th.el-table__cell.is-leaf {
        height: 96px;
      }

      .test_result {
        .test_result_left {
          width: 50%;
          box-sizing: border-box;
          border-right: 1px solid rgba(0, 0, 0, 0.1);

          .test_result_evaluation {
            min-height: 220px;
            color: #606060;
            line-height: 25px;
          }

          .test_result_evaluation_echarts {
            height: 300px;

            .total_view_top {
              font-size: 14px;
              color: #909090;

              .total_view_one {
                border-right: 1px solid rgba(0, 0, 0, 0.2);
                width: 25%;
                box-sizing: border-box;
              }

              .total_view_one_value {
                font-weight: bold;
                font-size: 22px;
                color: #303030;
              }

              .total_view_one_value_blue {
                color: #437fff;
              }

              .total_view_one_value_unit {
                font-size: 16px;
              }
            }

            .distribution_map {
              font-weight: 600;
              font-size: 14px;
              color: #2b88d8;
            }
          }
        }

        .test_result_right {
          border: none;
        }
      }

      .paper_analysis {
        color: #606060;
        line-height: 35px;
      }

      .question_analysis {
        .question_analysis_one {
          width: 33%;
          box-sizing: border-box;
          border-right: 1px solid rgba(0, 0, 0, 0.1);

          .question_analysis_one_text {
            font-size: 12px;
            color: #303030;

            .do_status {
              width: 9px;
              height: 9px;
              background: #14b119;
              border-radius: 3px;
            }

            .do_status_1 {
              background: #ff4949;
            }

            .do_status_2 {
              background: #ffa003;
            }
          }

          .echarts_box {
            width: 95%;
            height: 300px;
          }
        }

        .question_analysis_one_border {
          border: none;
        }
      }
    }
  }
}
</style>
